import React, { useCallback } from 'react';

import { Button, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  buttonBacktoDashboard: {
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '215px',
    },
  },
  buttonBacktoDashboardButtonContainer: {
    marginTop: '40px',
    textAlign: 'center',
  },
  finishElementContainer: {
    backgroundColor: '#F5F5F5',
    borderRadius: '5px',
    margin: '52px 0px 40px',
    padding: '20px',
  },
  finishElementDescription: {
    color: '#475C7E',
    fontSize: '12px',
    lineHeight: '18px',
  },
  finishElementTitle: {
    color: '#172B4D',
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '27px',
    marginBottom: '15px',
  },
  typographyDetail: {
    color: '#999999',
    fontSize: '12px',
    lineHeight: '20px',
    marginBottom: '0px',
    textAlign: 'center',
  },
}));

export default ({ onClickBackToDashboard, removeFileUploadDetail, userDetail }) => {
  const classes = useStyles();

  const renderDescriptionContent = useCallback(() => {
    const canRequestBeforePay = userDetail?.workspace?.canRequestBeforePay;

    if (canRequestBeforePay) {
      return (
        <>
          Now that we have received the necessary files to create your video report, all that is left is to choose your desired package and proceed to payment.
          <br /> <br />
          Once payment is confirmed our team will begin working on your personalized video report right away.
          <br /> <br />
          We look forward to helping you with your medical epiphany.
        </>
      );
    }

    return (
      <>
        Our team will start working on your video report right away.
        <br /> <br />
        You will receive an email notification with a link to view your personalised video report within 1-3 business days from today, based on the option you selected.
        <br /> <br />
        If we have have any questions we will reach out via the contact information that you have provided.
        <br /> <br />
        We look forward to helping you with your medical epiphany.
      </>
    );
  }, [userDetail]);

  const handleClickBackToDashboard = () => {
    if (onClickBackToDashboard) onClickBackToDashboard();
  };

  return (
    <div>
      {!removeFileUploadDetail && (
        <div style={{ textAlign: 'center' }}>
          <Typography className={classes.typographyDetail} style={{ marginBottom: '5px', marginLeft: 'auto', marginRight: 'auto', maxWidth: '410px' }}>
            Your files have been successfully uploaded to our system.
          </Typography>
          <Typography className={classes.typographyDetail} style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '500px' }}>
            It will take approximately 5-10 minutes for these new files to be processed and appear on your dashboard. An email will be sent to you once your dashboard has been
            updated.
          </Typography>
        </div>
      )}

      <div style={{ textAlign: 'left' }}>
        <div className={classes.finishElementContainer}>
          <Typography className={classes.finishElementTitle}>What happens next?</Typography>
          <Typography className={classes.finishElementDescription}>{renderDescriptionContent()}</Typography>
          <Typography className={classes.finishElementDescription} style={{ marginTop: '10px' }}>
            Regards,
            <br />
            <strong>The Mediphany Team</strong>
          </Typography>
        </div>
      </div>

      <div className={classes.buttonBacktoDashboardButtonContainer}>
        <Button onClick={handleClickBackToDashboard} variant="contained" color="primary" className={classes.buttonBacktoDashboard}>
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};
